import Vue from 'vue';
import Toasted from 'vue-toasted';
import PortalVue from 'portal-vue';
import vClickOutside from 'v-click-outside';
import VTooltip from 'v-tooltip';
import CKEditor from '@ckeditor/ckeditor5-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/style/tailwind.css';
import './assets/style/main.css';
import './plugins';

require('intersection-observer');

Vue.config.productionTip = false;

Vue.use(VTooltip);
Vue.use(vClickOutside);
Vue.use(PortalVue);
Vue.use(CKEditor);

Vue.use(Toasted, {
    position: 'bottom-center',
    duration: 6000,
});

Vue.toasted.register(
    'error',
    (payload) => {
        if (!payload.message) {
            return 'Something went wrong, try again later';
        }

        return payload.message;
    },
    {
        type: 'error',
    },
);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
